import { TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { ExchangeApiFormProps } from '../ExchangeApi';


const BitpandaForm: React.FC<ExchangeApiFormProps> = ({ formData, setFormData }) => {
    const { t } = useTranslation();
    
    return (
        <>
            <TextField
                sx={{ mb: 2 }}
                label={t('integrations.exchange.api.apiJobName')}
                value={formData.key_post}
                onChange={(e) => setFormData({ ...formData, key_post: e.target.value })}
            />
            <TextField
                sx={{ mb: 2 }}
                label={t('integrations.exchange.api.keySecretCombination')}
                type="password"
                value={formData.secret_post}
                onChange={(e) => setFormData({ ...formData, secret_post: e.target.value })}
            />
        </>
    );
};

// Export validation function separately so the main component can use it
export const isBitpandaFormValid = (formData: { key_post: string; secret_post: string }) => {
    return Boolean(formData.key_post && formData.secret_post);
};

export default BitpandaForm;
